module.exports = __webpack_public_path__ + "img/daren_2.ca1d368d.png";